import styled from '@emotion/styled';

export const Container = styled.button`
	outline: none;
	display: flex;
	flex-direction: column;
	border-radius: var(--large-border-radius);
	background: var(--background-3);
	padding: 1.5rem 2rem;
	border: 1px solid var(--border-color);
	width: 28rem;
	min-width: 28rem;
	height: 14.5rem;

	cursor: pointer;
	scroll-snap-align: center;

	&.selected {
		background: var(--background-1);
		color: var(--white);
		border-color: var(--blue);
	}

	:hover {
		border-color: var(--blue);
	}
`;

export const CardNumber = styled.div`
	display: flex;
	align-items: center;
	gap: 2rem;
	margin-top: 2rem;
	margin-bottom: 1.5rem;
`;

export const CardExpiry = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.2rem;
`;
